const API_ORIGIN =
  process.env.REACT_APP_API_ORIGIN ||
  process.env.REACT_APP_TASK_API_ORIGIN ||
  "https://fundswalla.in";

const buildAbsoluteUrl = (prefix, endpoint) =>
  `${API_ORIGIN}${prefix}/${String(endpoint).replace(/^\//, "")}`;

/** Always hit fundswalla.in TaskApi */
export const taskApiPostUrl = (endpoint) =>
  buildAbsoluteUrl("/Api/TaskApi", endpoint);

export const taskApiDirectUrl = (endpoint) =>
  buildAbsoluteUrl("/Api/TaskApi", endpoint);

/** PAN / Aadhaar OTP */
export const loanBackendUrl = (endpoint) =>
  buildAbsoluteUrl("/loan_backend", endpoint);

/** Lead save via TaskApi */
export const saveLendingPageUrl = () => taskApiPostUrl("saveLendingPage");

export const formatApiMessage = (message) => {
  if (typeof message !== "string") return "Something went wrong. Please try again.";
  return message.replace(/<br\s*\/?>/gi, "\n").replace(/<[^>]+>/g, "").trim();
};

/** Normalize success from TaskApi or loan_backend save responses */
export const isLeadSaveSuccess = (data) => {
  if (!data || typeof data !== "object") return false;
  if (data.Status === 1 || data.status === 1) return true;
  if (data.success === true) return true;
  return false;
};

export const getLeadSaveMessage = (data, fallback = "Something went wrong. Please try again.") =>
  formatApiMessage(data?.Message || data?.message || data?.error || fallback);

export const getLeadInsertedId = (data) =>
  data?.inserted_id || data?.insertedId || data?.Data?.inserted_id || data?.id || null;
